<footer class="theme-footer">
	<div class="footer-wrapper">
		<div class="flex align-item-center">
			<div class="col m-y-5">
				<p class="m-0">
					UI v. {{version.version}}  ({{version.hash}} {{version.date | date}}
					<span *ngIf="version.tag">tag {{version.tag}}</span>
					)
					<span
						class="ms-1"
						*ngIf="tickets">
						<a
							target="_blank"
							class="text-primary-500"
							[href]="tickets">
							{{'open-ticket' | translate}}
						</a>
					</span>
				</p>
			</div>

			<div class="col-auto">
				<ul class="list-inline footer-link m-b-0"></ul>
				<p class="m-0">
					Copyright © {{currentDate | date: 'yyyy'}} | 
					by
					<a
						href="https://elbuild.it"
						target="_blank"
						class="text-primary-500">
						ELbuild
					</a>
				</p>
			</div>

		</div>
	</div>
</footer>
